// Styles for OffersCobrandCardHorizontalFlexible go here.
import styled from 'styled-components';

export const StyledOffersCobrandCardHorizontalFlexible = styled.div``;
